import React from 'react';
import Divider from 'antd/lib/divider';
import 'antd/lib/divider/style/index.css';
var FormRoute = function (props) {
    var round = props.round;
    var route = props.route;
    return (React.createElement(React.Fragment, null,
        React.createElement("h3", null,
            React.createElement("strong", null,
                round.code,
                route.index + 1)),
        React.createElement(Divider, null)));
};
export default FormRoute;



//////////////////
// WEBPACK FOOTER
// ./src/pages/WorkspaceEvent/FormRoundPage/FormRoute/index.tsx
// module id = 1191
// module chunks = 0